/**
 * Kanonik rota yolları. Sabit string yerine bunları tercih edin; yeniden
 * adlandırmalar grep'lenebilir ve tip kontrollü kalsın. `core/routes.tsx` +
 * modül `*.routes.tsx` dosyalarıyla senkron tutun.
 */

export const ROUTES = {
  root: '/',
  app: '/app',
  forbidden: '/app/forbidden',

  categories: '/app/categories',
  questionPools: '/app/question-pools',
  questionGeneration: '/app/question-generation',
  questionGenerationNew: '/app/question-generation/new',
  questionGenerationEditDraft: '/app/question-generation/$id/edit',
  periodicGeneration: '/app/periodic-generation',
  periodicGenerationNew: '/app/periodic-generation/new',
  periods: '/app/periods',
  periodsNew: '/app/periods/new',
  roles: '/app/roles',
  users: '/app/users',
  auditLogs: '/app/audit-logs',
  profile: '/app/profile',

  auth: {
    signIn: '/',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },
} as const

export type TRoutePath =
  | (typeof ROUTES)[keyof Omit<typeof ROUTES, 'auth'>]
  | (typeof ROUTES.auth)[keyof typeof ROUTES.auth]
